export const siteInfo = {
  name: "黄色大片",
  slogan: "最新热门电影资讯与推荐",
  description:
    "黄色大片致力于为影迷提供最新的电影资讯、精选影片推荐与深度影评。从院线热映到专题盘点，帮你在海量影片中，快速找到今天想看的那一部。",
  intro:
    "我们相信，选对一部电影，就能改变一整个夜晚的心情。黄色大片汇聚编辑精选与影迷口碑，用专业的资料与真诚的分享，陪你一起走进光影世界。",
  email: "hello@yellowblockbuster.example.com",
  address: "光影大厦 · 影迷内容中心",
  icp: "演示站点 · 内容为虚构示例",
};

export interface NavLink {
  label: string;
  to: string;
}

export const navLinks: NavLink[] = [
  { label: "首页", to: "/" },
  { label: "分类", to: "/category/action" },
  { label: "专题", to: "/special" },
  { label: "搜索", to: "/search" },
  { label: "关于", to: "/about" },
];

export interface SocialLink {
  label: string;
  icon: string;
  href: string;
}

export const socialLinks: SocialLink[] = [
  { label: "微博", icon: "ri-weibo-line", href: "#" },
  { label: "微信", icon: "ri-wechat-line", href: "#" },
  { label: "抖音", icon: "ri-tv-2-line", href: "#" },
  { label: "小红书", icon: "ri-book-2-line", href: "#" },
];